const api = require('./config.json');
export const API_URL = api.api_url;


export function MEDIA_GET(id, token) {
    return {
      url: API_URL + `/media/${id}`,
      options: {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    };
  }

  // id é da campanha que será feita a busca
  export function MEDIA_SEARCH(id, token, body) {
    return {
      url: API_URL + `/media/${id}`,
      options: {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    };
  }

  export function MEDIA_GET_PAGE(id, token, pageNumber) {
    return {
      url: API_URL + `/media/${id}?page=${pageNumber}`,
      options: {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    };
  }

  export function MEDIA_APPROVADED(id, token, body) {
    return {
      url: API_URL + `/media_check/${id}`,
      options: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(body),
      },
    };
  }

  export function MEDIA_DISABLE(id, token) {
    return {
      url: API_URL + `/media/${id}`,
      options: {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token
        },
      },
    };
  }

  export function MEDIA_ENABLE(id, token) {
    return {
      url: API_URL + `/media/${id}`,
      options: {
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + token
        },
      },
    };
  }

  
